module.exports = __webpack_public_path__ + "static/media/Glitch-3.888cfb20.webp";